import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import * as _ from 'lodash';

export interface ResourceGroupsDialogDialogInf {
  selectedItem: any;
  isEditMode?: boolean;
  nodes: Array<object>;
  pCons: Array<object>;
  voipPeers: Array<object>;
  callsQuotas: Array<object>;
  elementTypes: Array<object>;
}

@Component({
  selector: 'resource-groups-dialog',
  templateUrl: './resource-groups-dialog.component.html',
  styleUrls: ['./resource-groups-dialog.component.scss'],
})
export class ResourceGroupsDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ResourceGroupsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ResourceGroupsDialogDialogInf) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  elements = [];

  ngOnInit(): void {
    this.setGroupElements();
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data.selectedItem);
  }

  clearElements(): void {
    this.data.selectedItem.elements = [];
  }

  isPeerConnectionType(): boolean {
    return this.data && this.data.selectedItem &&
        this.data.selectedItem.type === 'PEER_CONNECTION';
  }

  setGroupElements(): void {
    if (_.isNil(this.data) || _.isNil(this.data.selectedItem)) {
      this.elements = [];
    }

    switch (this.data.selectedItem.type) {
      case 'NODE':
        this.elements = this.data.nodes;
        break;
      case 'PEER_CONNECTION':
        this.elements = this.data.pCons;
        break;
      case 'VOIP_PEER':
        this.elements = this.data.voipPeers;
        break;
      default:
        this.elements = [];
    }
  }

  isElementSelected(): boolean {
    return this.data.selectedItem.elements && this.data.selectedItem.elements.length === 0;
  }
}
